import { render, staticRenderFns } from "./ReviewsSettingsCreateOrEditConfirmBusinessTab.vue?vue&type=template&id=3274741d&"
import script from "./ReviewsSettingsCreateOrEditConfirmBusinessTab.vue?vue&type=script&lang=js&"
export * from "./ReviewsSettingsCreateOrEditConfirmBusinessTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports